const MINUS = '−'; // U+2212 minus sign; matches mockup

export function fmtN(n: number): string {
  return Math.round(n).toLocaleString('da-DK');
}

export function kr(n: number): string {
  const rounded = Math.round(n);
  const abs = Math.abs(rounded).toLocaleString('da-DK');
  return rounded < 0 ? `-${abs} kr.` : `${abs} kr.`;
}

export function signN(n: number): string {
  const rounded = Math.round(n);
  const abs = Math.abs(rounded).toLocaleString('da-DK');
  return rounded < 0 ? `${MINUS}${abs}` : `+${abs}`;
}

export function signKr(n: number): string {
  return `${signN(n)} kr.`;
}
